import React, { memo } from "react";
import { Icon } from "@iconify/react";

const PromotionCard = ({
  promotion,
  onClick,
  onSelect,
  getImg,
  makeSvgPlaceholder,
  bonusText,
  depositText,
  disabledSelect,
  isSelected,
}) => (
  <div
    onClick={() => onClick?.(promotion)}
    style={{
      position: "relative",
      backgroundColor: "#1f2937",
      borderRadius: 12,
      overflow: "hidden",
      cursor: "pointer",
      transition: "all 0.3s ease",
      border: isSelected ? "2px solid #22c55e" : "1px solid #404040",
      boxShadow: isSelected
        ? "0 4px 20px rgba(34, 197, 94, 0.3)"
        : "0 2px 8px rgba(0, 0, 0, 0.2)",
    }}
    onMouseEnter={(e) => {
      if (!isSelected) {
        e.currentTarget.style.transform = "translateY(-4px)";
        e.currentTarget.style.boxShadow = "0 8px 24px rgba(0, 0, 0, 0.3)";
      }
    }}
    onMouseLeave={(e) => {
      if (!isSelected) {
        e.currentTarget.style.transform = "translateY(0)";
        e.currentTarget.style.boxShadow = "0 2px 8px rgba(0, 0, 0, 0.2)";
      }
    }}
  >
    {/* Image Section */}
    <div
      style={{
        position: "relative",
        width: "100%",
        paddingTop: "56.25%",
        backgroundColor: "#1a1a1a",
        overflow: "hidden",
      }}
      onClick={() => onClick?.(promotion)}
    >
      <img
        src={getImg(promotion, 400, 220)}
        alt={promotion.Detail}
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          objectFit: "cover",
        }}
        onError={(e) => {
          e.currentTarget.onerror = null;
          e.currentTarget.src = makeSvgPlaceholder(400, 220);
        }}
      />

      {/* Selected Badge - Top Right */}
      {isSelected && (
        <div
          style={{
            position: "absolute",
            top: 12,
            right: 12,
            width: 40,
            height: 40,
            borderRadius: "50%",
            background: "rgba(34, 197, 94, 0.95)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            boxShadow: "0 2px 12px rgba(34, 197, 94, 0.5)",
            zIndex: 10,
          }}
        >
          <Icon
            icon="mdi:check-circle"
            width="28"
            height="28"
            style={{ color: "#fff" }}
          />
        </div>
      )}
    </div>

    {/* Content Section */}
    <div style={{ padding: 16 }}>
      <h3
        style={{
          color: isSelected ? "#22c55e" : "#fff",
          fontSize: 18,
          fontWeight: 600,
          marginBottom: 12,
          lineHeight: 1.4,
        }}
      >
        {promotion.Detail}
      </h3>

      {/* Badges */}
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: 8,
          marginBottom: 16,
        }}
      >
        {depositText(promotion) && (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: 8,
              fontSize: 14,
              color: "#d1d5db",
            }}
          >
            <Icon
              icon="mdi:cash-plus"
              width="16"
              height="16"
              style={{ color: "var(--primaryColor)" }}
            />
            <span>{depositText(promotion)}</span>
          </div>
        )}
        {bonusText(promotion) && (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: 8,
              fontSize: 14,
              color: "#d1d5db",
            }}
          >
            <Icon
              icon="mdi:gift-outline"
              width="16"
              height="16"
              style={{ color: "var(--primaryColor)" }}
            />
            <span>{bonusText(promotion)}</span>
          </div>
        )}
      </div>

      {/* Action Buttons */}
      <div
        style={{
          display: "flex",
          gap: 8,
        }}
      >
        <button
          onClick={(e) => {
            e.stopPropagation();
            onClick?.(promotion);
          }}
          style={{
            flex: 1,
            padding: "10px 16px",
            background: "rgba(245, 158, 11, 0.1)",
            border: "1px solid rgba(245, 158, 11, 0.3)",
            borderRadius: 6,
            color: "var(--primaryColor)",
            fontSize: 14,
            fontWeight: 500,
            cursor: "pointer",
            transition: "all 0.2s",
          }}
          onMouseEnter={(e) => {
            e.target.style.background = "rgba(245, 158, 11, 0.2)";
          }}
          onMouseLeave={(e) => {
            e.target.style.background = "rgba(245, 158, 11, 0.1)";
          }}
        >
          รายละเอียด
        </button>
      </div>
    </div>
  </div>
);

export default memo(PromotionCard);
